import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { DataPagination } from 'src/app/shared/interfaces/data-pagination';
import { DataQuery } from 'src/app/shared/interfaces/data-query';
import { Observable } from 'rxjs';
import { CurrencyExchangeElement } from '../users/dashboard/dashboard.component';

@Injectable({
  providedIn: 'root'
})
export class ParameterService {

    constructor(private http: HttpClient) { }

    getParametroList_v1() {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('token_jwt')));

        return this.http.get(`${environment.BACKEND_URL}/list-of-values`, { headers: headers });
    }
    getParametroList(pagination: DataPagination,query: DataQuery): Observable<any>{
        const params = {}
        const json = { ...query, ...pagination, }
        for(let idx in json) params[idx] = `${json[idx]}`
    
        
    
        if(query.to_xls != 1){
          return this.http.get<{data: Array<CurrencyExchangeElement>, [key: string]: number | string | Array<CurrencyExchangeElement>}>(`${environment.BACKEND_URL}/list-of-values`,{params})
        }
    
    
        const opts = {
          headers: new HttpHeaders({
            'Accept': '*/*',
          }),
          params,
          reportProgress: false,
          responseType: 'blob',
          observe: 'response',
        }
        return this.http.get(`${environment.BACKEND_URL}/list-of-values`,opts as any)
        
      }
    getParametro(id) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('token_jwt')));

        return this.http.get(`${environment.BACKEND_URL}/list-of-values/`+ id, { headers: headers });
    }

    getlDVByCat(id){
      let headers = new HttpHeaders();
      headers = headers.set('Content-type', 'application/json');
      headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('token_jwt')));

      return this.http.get(`${environment.BACKEND_URL}/ldv-by-param/`+ id, { headers: headers });
    }

    getlDVByRef1(id){
      let headers = new HttpHeaders();
      headers = headers.set('Content-type', 'application/json');
      headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('token_jwt')));

      return this.http.get(`${environment.BACKEND_URL}/ldv-by-ref1/`+ id, { headers: headers });
    }

    createParametro(objectData) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('token_jwt')));

        return this.http.post(`${environment.BACKEND_URL}/list-of-values`, { data: objectData }, { headers: headers });
    }

    updateParametro(idObject, updateObject) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('token_jwt')));
        return this.http.put(`${environment.BACKEND_URL}/list-of-values/` + idObject, { data: updateObject }, { headers: headers });
    }

    delete(id: number | string) {
        return this.http.delete(`${environment.BACKEND_URL}/list-of-values/${id}`);
    }

   


}


